import React from 'react';
import { ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
type KpiCardProps = {
  title: string;
  value: string;
  change: string;
  trend: 'up' | 'down';
  icon: React.ReactNode;
  color: 'blue' | 'purple' | 'green' | 'orange';
};
export const KpiCard: React.FC<KpiCardProps> = ({
  title,
  value,
  change,
  trend,
  icon,
  color
}) => {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-700',
    purple: 'bg-purple-50 text-purple-700',
    green: 'bg-green-50 text-green-700',
    orange: 'bg-orange-50 text-orange-700'
  };
  const iconColorClasses = {
    blue: 'bg-blue-100',
    purple: 'bg-purple-100',
    green: 'bg-green-100',
    orange: 'bg-orange-100'
  };
  const trendColorClasses = {
    up: 'text-green-600',
    down: 'text-red-600'
  };
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-458">
      <div className="flex items-center" data-id="element-459">
        <div className={`w-12 h-12 rounded-lg ${iconColorClasses[color]} flex items-center justify-center mr-4`} data-id="element-460">
          {icon}
        </div>
        <div data-id="element-461">
          <h3 className="text-sm font-medium text-gray-500" data-id="element-462">{title}</h3>
          <div className="flex items-baseline mt-1" data-id="element-463">
            <p className="text-2xl font-semibold text-gray-900" data-id="element-464">{value}</p>
            <p className={`ml-2 flex items-center text-sm ${trendColorClasses[trend]}`} data-id="element-465">
              {trend === 'up' ? <ArrowUpIcon size={16} className="mr-0.5" data-id="element-466" /> : <ArrowDownIcon size={16} className="mr-0.5" data-id="element-467" />}
              {change}
            </p>
          </div>
        </div>
      </div>
    </div>;
};